import React, { Component } from 'react';
import { connect } from 'react-redux';

import { History } from 'history';

import { receiveError } from '../../../../store/actions/notificationAction';
import { getGhaInfo } from '../../../../store/actions/ghaAction';
import { receiveGhaOrderAwbs } from '../../../../store/actions/awbsAction';

import ghaRemote from '../../../../api/ghaRemote';
import forwarderRemote from '../../../../api/forwarderRemote';
import pickupOrderRemote from '../../../../api/pickupOrderRemote';

import ManualEntryModal from './ManualEntryModal';

import User from '../../../../models/User';
import GhaDock from '../../../../models/GhaDock';
import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import ForwarderModel from '../../../../models/ForwarderAwb';
import ForwarderNewModel from '../../../../models/ForwarderNew';
import ForwarderLocationModel from '../../../../models/ForwarderLocation';
import PickupOrderGha from '../../../../models/PickupOrderGha';
import DriverInfoModel from '../../../../models/GhaManualEntryDriverInfo';
import ManualEntryEdit from '../../../../models/ManualEntryEdit';
import DriverTruckEdit from '../../../../models/DriverTruckEdit';
import { DelivererType } from '../../../../models/DelivererType.enum';
import ManualEntryEditDriverData from '../../../../models/ManualEntryEditDriverData';
import StationsModel from '../../../../models/Stations';
import GhaModel from '../../../../models/Gha';

import moment from 'moment';
import queueRemote from '../../../../api/queueRemote';
import DriverQueue from '../../../../models/DriverQueue';
import userManagementReqHandler from '../../../../api/userManagementRemote';
import AirlineType from '../../../../models/AirlineType';
import ManualEntryAdd from '../../../../models/ManualEntryAdd';

const ALL: boolean = true;
const initialErrors = {
  driverName: '',
  driverIdType: '',
  driverId: '',
  truckPlateNumber: '',
  truckingCompany: '',
  arrivalTime: '',
  rfsNumber: '',
};

interface ManualEntryModalContainerProps {
  type: string;
  receiveError: (error: any) => void;
  history: History;
  user: User;
  getGhaInfo: Function;
  modalOpen: boolean;
  handleCloseModal: (isUpdated?: boolean, edit?: boolean, cancel?: boolean) => void;
  driverData: {
    name: string;
    company: string;
    check_in: any;
    driverId?: number;
  };
  getGhaOrderAwbs: (orderNumber: string) => void;
  manualEntryEdit: ManualEntryEdit;
  manualEntryAdd: ManualEntryAdd;
  gha: GhaModel;
};

interface ManualEntryModalContainerState {
  forwarders: Array<ForwarderNewModel>;
  forwarderValue: number | undefined;
  forwarderLocationValue: number | undefined;
  forwarderName: string;
  isCreateFwd: boolean;
  ghaDocks: Array<GhaDock>;
  driverInfo: DriverInfoModel;
  selectedDock: number | null;
  errors: DriverInfoModel;
  forwarderError: string;
  forwarderNameError: string;
  delivererType: string;
  editDriverData: ManualEntryEditDriverData;
  stations: Array<StationsModel>;
  stationValue: string;
  cityCodes: Array<StationsModel>;
  cityCodeValue: string; 
  cityCodeError: string;
  openModalRecheckFwd: boolean;
  relevantForwarders: Array<ForwarderNewModel>;
  selectedForwarder: string;
  selectedForwarderLocationValue: string;
  airlines: AirlineType[];
};

class ManualEntryModalContainer extends Component<ManualEntryModalContainerProps, ManualEntryModalContainerState> {

  state: ManualEntryModalContainerState = {
    forwarders:[],
    forwarderValue: undefined,
    forwarderLocationValue: undefined,
    forwarderName: '',
    isCreateFwd: false,
    ghaDocks: [],
    driverInfo: {
      driverName: '',
      driverId: '',
      driverIdType: '',
      truckPlateNumber: '',
      truckingCompany: '',
      arrivalTime: '',
      rfsNumber: '',
      interlineTransfer: '',
      forwarderLocation: 0
    },
    errors: initialErrors,
    forwarderError: '',
    selectedDock: null,
    forwarderNameError: '',
    delivererType: DelivererType.FORWARDER,
    editDriverData: {
      driverId: '',
      driverIdType: '',
      name: '',
      truckPlateNumber: '',
      company: '',
      driverTime: '',
      rfsNumber: ''
    },
    stations: [],
    stationValue: '',
    cityCodes: [],
    cityCodeValue: '',
    cityCodeError: '',
    openModalRecheckFwd: false,
    relevantForwarders: [],
    selectedForwarder: '',
    selectedForwarderLocationValue: '',
    airlines: [],
  }

  componentDidMount() {

    let delivererType: string = DelivererType.FORWARDER;
    this.props.getGhaInfo(this.props.user.gha_id);
    this.getGhaDocks(this.props.user.gha_id);
    this.getGhaAirlines();
    if (!this.props.manualEntryEdit.isEditMode) {
      this.setDriverInfo();
    }
    let forwarderValue = this.state.forwarderValue;
    if (this.props.manualEntryEdit.isEditMode || this.props.manualEntryAdd.isAddMode) {
      forwarderValue = this.props.manualEntryEdit.forwarderId ? this.props.manualEntryEdit.forwarderId : undefined;
      this.setEditModeData(this.props.manualEntryEdit.isEditMode ? this.props.manualEntryEdit : this.props.manualEntryAdd);
      if(this.props.manualEntryAdd && this.props.manualEntryAdd.isAddMode) {
        delivererType = this.props.manualEntryAdd.isInterline ? DelivererType.INTERLINE: this.props.manualEntryAdd.isRfs ? DelivererType.RFS : DelivererType.FORWARDER;
      } else {
        delivererType = this.props.manualEntryEdit.isInterline ? DelivererType.INTERLINE: this.props.manualEntryEdit.isRfs ? DelivererType.RFS : DelivererType.FORWARDER;
      }
    }

    if (this.props.type === 'go') {
      delivererType = 'go';
      this.setState({ delivererType: 'go' });
    }

    this.loadStations();
    this.setState({ stationValue: this.props.gha.info.location, forwarderValue });
    this.loadForwarders(this.props.gha.info.location,delivererType);
  }

  componentDidUpdate(prevProps: ManualEntryModalContainerProps): void {

    if (this.props.manualEntryEdit.isEditMode && prevProps.manualEntryEdit.isEditMode && this.props.manualEntryEdit.driverData != prevProps.manualEntryEdit.driverData) {
      this.setEditModeData(this.props.manualEntryEdit);
    }
  }

  loadForwarders = (code: string, type: string): void => {

    const gha: number = this.props.gha.id;
    
    if (type === DelivererType.FORWARDER) {
      this.setState({ forwarders: [] });
    } else {
      forwarderRemote.getStationForwarders({ code, type, gha }).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
        const forwarders: Array<ForwarderNewModel> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (forwarders && forwarders.length > 0) {
          this.setState({ forwarders: forwarders as any, forwarderName: forwarders[0].name, forwarderValue: forwarders[0].id, forwarderLocationValue: forwarders[0].forwarder_location_id });
        }

        if (error) {
          this.props.receiveError(error);
        }
      });
    }
  }

  setDriverInfo = (): void => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    driverInfo.driverName = this.props.driverData.name;
    driverInfo.truckingCompany = this.props.driverData.company;
    driverInfo.waitingListId = this.props.driverData.driverId;
    driverInfo.arrivalTime = this.props.driverData.check_in ? moment(this.props.driverData.check_in).format('HH:mm'): this.setArrivalTime();

    this.setState({ driverInfo });
  }

  setEditModeData = (editModeData: ManualEntryEdit | ManualEntryAdd): void => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    const editDriverData: ManualEntryEditDriverData = editModeData.driverData;
    driverInfo.driverId = editDriverData.driverId;
    driverInfo.maskedDriverId = editDriverData.driverId.replace(/.(?=.{4,}$)/g, '#');
    driverInfo.driverIdType = editDriverData.driverIdType;
    driverInfo.driverName = editDriverData.name;
    driverInfo.truckingCompany = editDriverData.company;
    driverInfo.truckPlateNumber = editDriverData.truckPlateNumber;
    driverInfo.rfsNumber = editDriverData.rfsNumber;
    driverInfo.arrivalTime = editDriverData.driverTime && editDriverData.driverTime.length === 4 ? (editDriverData.driverTime.substring(0, 2) + ':' + editDriverData.driverTime.substring(2, 4)) : ''
    const forwarder: ForwarderModel | undefined = this.state.forwarders.find((forwarder: ForwarderModel) => { return forwarder.id === editModeData.forwarderId });

    this.setState({
      editDriverData,
      driverInfo,
      forwarderValue: editModeData.forwarderId,
      selectedDock: editModeData.dockId ? editModeData.dockId : null,
      delivererType: editModeData.isInterline ? DelivererType.INTERLINE: editModeData.isRfs ? DelivererType.RFS : DelivererType.FORWARDER,
      forwarderName: forwarder && forwarder.name || ''
    });
  }

  getGhaDocks = (ghaID: any): void => {

    ghaRemote.getGhaDocks(ghaID).then((resp: ApiResponse<Array<GhaDock>>) => {

      const docks: Array<GhaDock> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (docks && docks.length > 0) {
        this.setState({ ghaDocks: docks });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  getGhaAirlines = () => {
    userManagementReqHandler.getAirlines().then(resp => {
      const airlines: Array<AirlineType> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      }

      if(airlines) {
        this.setState({ airlines: airlines });
      }
    })
  }


  setArrivalTime = (): string => {

    let driverInfo: DriverInfoModel = { ...this.state.driverInfo };

    const date = new Date()
    const time = moment(date).format('HH:mm').toString();
    driverInfo.arrivalTime = time;
    this.setState ({ driverInfo });

    return time;
  }

  handleOpenCreateFwd = (): void => {

    this.setState({isCreateFwd: true });
    this.loadCityCodes();
  }

  handleChange = (propertyName: string, event: any): void => {

    let value: any;

    if (propertyName === 'forwarderCompany') {
      const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
      this.setState({ forwarderValue: event.forwarderId });
      this.setState({ forwarderLocationValue: event.value });
      this.setState({ forwarderName: event.label });
      this.setState({ forwarders: [{ id: event.forwarderId, forwarder_location_id: event.value, name: event.label }] as any });
      return;
    }

    if (propertyName === 'forwarderStation' || propertyName === 'cityCode') {
      value = event.value;
    }
    else {
      value = event.target.value;
    }

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };

    switch (propertyName) {
      case 'forwarderStation':
        this.setState({ stationValue: value});
        this.loadForwarders(value,this.state.delivererType);
        this.setState({ forwarderValue: undefined });
        this.setState({ forwarderLocationValue: undefined });
        this.setState({ forwarderName: '' });
      break;
      case 'forwarderName': this.setState({ forwarderName: value }); break;
      case 'driverName': driverInfo.driverName = value ; break;
      case 'driverId':
        driverInfo.driverId = value;
        driverInfo.maskedDriverId = value;
      break;
      case 'driverIdType': driverInfo.driverIdType = value; break;
      case 'truckPlateNumber': driverInfo.truckPlateNumber = value; break;
      case 'truckingCompany': driverInfo.truckingCompany = value; break;
      case 'arrivalTime': this.changeArrivalTime(value); break;
      case 'dockNumber': this.setState({ selectedDock: value }); break;
      case 'rfsNumber': driverInfo.rfsNumber = value ; break;
      case 'cityCode': this.setState({ cityCodeValue: value}); break;
      case 'airline': driverInfo.interlineTransfer = value ; break;
      default: break;
    }

    if (propertyName !== 'arrivalTime') {
      this.setState({ driverInfo });
    }
  }

  deleteItemOfDriverInQueue = async (driverId: number): Promise<void> => {

    try {
      const resp: ApiResponse<Array<DriverQueue>> = await queueRemote.deleteDriverOfQueue(driverId)
    }
    catch (error) {

      return this.props.receiveError(error);
    }
  }

  handleCreateForwarder = (): void => {

    if (this.state.forwarderName !== '') {
      if (this.state.cityCodeValue !== '') {
        // check if forwarder name & location exists
        forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue, is_active: true, ghaId: this.props.gha.id}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
          const existingFwd: Array<ForwarderNewModel> | undefined = resp.result;
          const existsFwderror: ResponseError | undefined = resp.error;
          if (existsFwderror) {
            this.props.receiveError(existsFwderror);
          }
          if (existingFwd) {
            if (existingFwd.length === 0) {
              // check if forwarder name exists
              forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                const fwdWithName: Array<ForwarderNewModel> | undefined = resp.result;
                const fwdWithNameerror: ResponseError | undefined = resp.error;
                if (fwdWithNameerror) {
                  this.props.receiveError(fwdWithNameerror);
                }
                if (fwdWithName) {
                  if (fwdWithName.length !== 0) {
                    // check for name & location
                    forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                      const fwdWNameIata: Array<ForwarderNewModel> | undefined = resp.result;
                      const fwdWNameIataerror: ResponseError | undefined = resp.error;
                      if (fwdWNameIataerror) {
                        this.props.receiveError(fwdWNameIataerror);
                      }
                      if (fwdWNameIata) {
                        if (fwdWNameIata.length !== 0) {
                          // check for name, location & active
                          forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue, is_active: true}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                            const fwdWNameIataActive: Array<ForwarderNewModel> | undefined = resp.result;
                            const fwdWNameIataActiveerror: ResponseError | undefined = resp.error;
                            if (fwdWNameIataActiveerror) {
                              this.props.receiveError(fwdWNameIataActiveerror);
                            }
                            if (fwdWNameIataActive) {
                              if (fwdWNameIataActive.length !== 0) {
                                // check first if gha is NULL
                                forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue, is_active: true, nullCheck: true}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                                  const fwdWNameIataActiveNullGha: Array<ForwarderNewModel> | undefined = resp.result;
                                  const fwdWNameIataActiveNullGhaerror: ResponseError | undefined = resp.error;
                                  if (fwdWNameIataActiveNullGhaerror) {
                                    this.props.receiveError(fwdWNameIataActiveNullGhaerror);
                                  }
                                  if (fwdWNameIataActiveNullGha) {
                                    if (fwdWNameIataActiveNullGha.length !== 0) {
                                      this.setState({ forwarderNameError: 'Forwarding Company already exists' });
                                    }
                                    else {
                                      // check for name, location, active & gha_id
                                      forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue, is_active: true, ghaId: this.props.gha.id}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                                        const fwdWNameIataActiveGha: Array<ForwarderNewModel> | undefined = resp.result;
                                        const fwdWNameIataActiveGhaerror: ResponseError | undefined = resp.error;
                                        if (fwdWNameIataActiveGhaerror) {
                                          this.props.receiveError(fwdWNameIataActiveGhaerror);
                                        }
                                        if (fwdWNameIataActiveGha) {
                                          if (fwdWNameIataActiveGha.length !== 0) {
                                            this.setState({ forwarderNameError: 'Forwarding Company already exists' });
                                          }
                                          else {
                                            // add the new location for fwd with active and gha id
                                            forwarderRemote.addForwarderLocation(fwdWNameIataActive[0].id,this.state.cityCodeValue,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                                              const fwdLocation: ForwarderLocationModel | undefined = resp.result;
                                              const fwdLocationerror: ResponseError | undefined = resp.error;

                                              if (fwdLocation) {
                                                this.loadStations();
                                                this.setState({ stationValue: this.state.cityCodeValue });

                                                this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                                                this.setState({ cityCodeValue: '', forwarderValue: fwdLocation.id_forwarder, forwarderLocationValue: fwdLocation.id, isCreateFwd: false });
                                              }
                                              if (fwdLocationerror) {
                                                this.props.receiveError(fwdLocationerror);
                                              }
                                            });
                                          }
                                        }
                                      });
                                    }
                                  }
                                });
                              }
                              else { // fwd inactive for given location
                                // check if inactive fwd has gha NULL
                                forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue, nullCheck: true}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                                  const fwdWNameIataInactiveNullGha: Array<ForwarderNewModel> | undefined = resp.result;
                                  const fwdWNameIataInactiveNullGhaerror: ResponseError | undefined = resp.error;
                                  if (fwdWNameIataInactiveNullGhaerror) {
                                    this.props.receiveError(fwdWNameIataInactiveNullGhaerror);
                                  }
                                  if (fwdWNameIataInactiveNullGha) {
                                    if (fwdWNameIataInactiveNullGha.length !== 0) {
                                      this.setState({ forwarderNameError: 'Forwarding Company already exists and is inactive' });
                                    }
                                    else {
                                      // check if the gha is already present else
                                      forwarderRemote.checkForwarderExists({forwarder_name: this.state.forwarderName, iata_code: this.state.cityCodeValue, ghaId: this.props.gha.id}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                                        const fwdWNameIataInactiveGha: Array<ForwarderNewModel> | undefined = resp.result;
                                        const fwdWNameIataInactiveGhaerror: ResponseError | undefined = resp.error;
                                        if (fwdWNameIataInactiveGhaerror) {
                                          this.props.receiveError(fwdWNameIataInactiveGhaerror);
                                        }
                                        if (fwdWNameIataInactiveGha) {
                                          if (fwdWNameIataInactiveGha.length !== 0) {
                                            this.setState({ forwarderNameError: 'Forwarding Company already exists and is inactive' });
                                          }
                                          else {
                                            // add new record with active location fwd and gha
                                            forwarderRemote.addForwarderLocation(fwdWNameIata[0].id,this.state.cityCodeValue,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                                              const fwdLocation: ForwarderLocationModel | undefined = resp.result;
                                              const fwdLocationerror: ResponseError | undefined = resp.error;
                                              if (fwdLocation) {
                                                this.loadStations();
                                                this.setState({ stationValue: this.state.cityCodeValue });

                                                this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                                                this.setState({ cityCodeValue: '', forwarderValue: fwdLocation.id_forwarder, forwarderLocationValue: fwdLocation.id, isCreateFwd: false });
                                              }
                                              if (fwdLocationerror) {
                                                this.props.receiveError(fwdLocationerror);
                                              }
                                            });
                                          }
                                        }
                                      });
                                    }
                                  }
                                });
                              }
                            }
                          });
                        }
                        else {
                          // add the new location with all active n gha_id
                          forwarderRemote.addForwarderLocation(fwdWithName[0].id,this.state.cityCodeValue,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                            const fwdLocation: ForwarderLocationModel | undefined = resp.result;
                            const fwdLocationerror: ResponseError | undefined = resp.error;

                            if (fwdLocation) {
                              this.loadStations();
                              this.setState({ stationValue: this.state.cityCodeValue });

                              this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                              this.setState({ cityCodeValue: '', forwarderValue: fwdLocation.id_forwarder, forwarderLocationValue: fwdLocation.id, isCreateFwd: false });
                            }
                            if (fwdLocationerror) {
                              this.props.receiveError(fwdLocationerror);
                            }
                          });
                        }
                      }
                    });
                  }
                  else {
                    // show relevant user popup
                    forwarderRemote.getForwaderByRelevance({ name: this.state.forwarderName, iata_code: this.state.cityCodeValue, ghaId: this.props.gha.id }).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                      const relevantForwarders: Array<ForwarderNewModel> | undefined = resp.result;
                      const relevantForwarderserror: ResponseError | undefined = resp.error;

                      if (relevantForwarders) {
                        if (relevantForwarders.length !== 0) {
                          this.setState({ openModalRecheckFwd: true });
                          this.setState({ relevantForwarders });
                        }
                        else {
                          //check if fwd name exists & it is inactive
                          forwarderRemote.getForwarderByName({forwarder_name: this.state.forwarderName}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
                            const fwdWName: Array<ForwarderNewModel> | undefined = resp.result;
                            const fwdWNameerror: ResponseError | undefined = resp.error;

                            if (fwdWNameerror) {
                              this.props.receiveError(fwdWNameerror);
                            }
                            if (fwdWName) {
                              if (fwdWName.length !== 0) {
                                // check if fwd has location(s)
                                forwarderRemote.getForwarderLocation({fwdId: fwdWName[0].id}).then((resp: ApiResponse<Array<ForwarderLocationModel>>) => {
                                  const fwdLocations: Array<ForwarderLocationModel> | undefined = resp.result;
                                  const fwdLocationserror: ResponseError | undefined = resp.error;

                                  if (fwdLocationserror) {
                                    this.props.receiveError(fwdLocationserror);
                                  }
                                  if (fwdLocations) {
                                    if (fwdLocations.length === 0) {
                                      // check if fwd is active
                                      if (fwdWName[0].is_active === true) {
                                        // add the new location with all active n gha_id
                                        forwarderRemote.addForwarderLocation(fwdWName[0].id,this.state.cityCodeValue,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                                          const fwdLocationNw: ForwarderLocationModel | undefined = resp.result;
                                          const fwdLocationNwerror: ResponseError | undefined = resp.error;

                                          if (fwdLocationNw) {
                                            this.loadStations();
                                            this.setState({ stationValue: this.state.cityCodeValue });

                                            this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                                            this.setState({ cityCodeValue: '', forwarderValue: fwdLocationNw.id_forwarder, forwarderLocationValue: fwdLocationNw.id, isCreateFwd: false });
                                          }
                                          if (fwdLocationNwerror) {
                                            this.props.receiveError(fwdLocationNwerror);
                                          }
                                        });
                                      }
                                      else { // fwd inactive
                                        // update the is_active for fwd to true, added as local & add the new location with all active & gha_id
                                        forwarderRemote.updateForwarderStatus(fwdWName[0].id,this.state.cityCodeValue,true,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                                          const activeFwdLocation: ForwarderLocationModel | undefined = resp.result;
                                          const activeFwdLocationerror: ResponseError | undefined = resp.error;

                                          if (activeFwdLocation) {
                                            this.loadStations();
                                            this.setState({ stationValue: this.state.cityCodeValue });

                                            this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                                            this.setState({ cityCodeValue: '', forwarderValue: activeFwdLocation.id_forwarder, forwarderLocationValue: activeFwdLocation.id, isCreateFwd: false });
                                          }
                                          if (activeFwdLocationerror) {
                                            this.props.receiveError(activeFwdLocationerror);
                                          }
                                        });
                                      }
                                    }
                                  }
                                });
                              }
                              else {
                                // save the location & forwarder name
                                forwarderRemote.createForwarder(this.state.forwarderName, 'forwarder', this.state.cityCodeValue, 'local', true,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                                  const forwarder: ForwarderLocationModel | undefined = resp.result;
                                  const error: ResponseError | undefined = resp.error;
                                  if (forwarder) {
                                    this.loadStations();
                                    this.setState({ stationValue: this.state.cityCodeValue });

                                    this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                                    this.setState({ openModalRecheckFwd: false });
                                    this.setState({ cityCodeValue: '', forwarderValue: forwarder.id_forwarder, forwarderLocationValue: forwarder.id, isCreateFwd: false, selectedForwarder: '' });
                                  }
                                  if (error) {
                                    this.props.receiveError(error);
                                  }
                                });
                              }
                            }
                          });
                        }
                      }
                      if (relevantForwarderserror) {
                        this.props.receiveError(relevantForwarderserror);
                      }
                    });
                  }
                }
              });
            }
            else {
              this.setState({ forwarderNameError: 'Forwarding Company already exists' });
            }
          }
        });
      }
      else {
        this.setState({ cityCodeError: 'Select IATA City Code' });
      }
    }
    else {
      this.setState({ forwarderNameError: 'Add Forwarding Company Name' });
    }
  }

  handleSubmit = async (): Promise<void> => {

    const isValid: boolean = this.isValid();
    console.log('🚀 ~ ManualEntryModalContainer ~ isValid:', isValid)
    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    if (!isValid && this.props.manualEntryEdit.isEditMode && this.props.manualEntryEdit.orderNumber) {
      driverInfo.driverName = this.state.editDriverData.name || '';
      driverInfo.driverId = this.state.editDriverData.driverId || '';
      driverInfo.driverIdType = this.state.editDriverData.driverIdType;
      driverInfo.truckPlateNumber = this.state.editDriverData.truckPlateNumber || '';
      driverInfo.rfsNumber = this.state.editDriverData.rfsNumber || '';
      driverInfo.truckingCompany = this.state.editDriverData.company || '';
      driverInfo.forwarderLocation = this.state.forwarderLocationValue || 0;
      driverInfo.arrivalTime = this.state.driverInfo.arrivalTime ? this.state.driverInfo.arrivalTime.replace(':', '') : '';

      const updatedDrvTrkData: DriverTruckEdit = {
        orderNumber: this.props.manualEntryEdit.orderNumber,
        delivery_company_name: this.props.manualEntryEdit.driverData.company,
        delivery_company_name_new: this.state.driverInfo.truckingCompany,
        driver_id: this.state.driverInfo.driverId,
        driver_id_type: this.state.driverInfo.driverIdType,
        driver_name: this.state.driverInfo.driverName,
        driver_vehichle_registration: this.state.driverInfo.truckPlateNumber,
        rfs_number: this.state.driverInfo.rfsNumber,
        id_dock: this.state.selectedDock || null,
        driver_checkin_time: this.state.driverInfo.arrivalTime ? this.state.driverInfo.arrivalTime.replace(':', '') : null
      };

      let apiResponseOrder: ApiResponse<PickupOrderGha>;

      try {
        apiResponseOrder = await pickupOrderRemote.saveGhaExportDriverInfo(updatedDrvTrkData.orderNumber, updatedDrvTrkData);

        if (apiResponseOrder.result) {
          this.props.handleCloseModal(false, true);
        }

        if (apiResponseOrder.error) {
          this.props.receiveError(apiResponseOrder.error);
        }
      } catch (error) {
        return this.props.receiveError(error);
      }
    }

    if (!isValid && (this.state.forwarderValue || this.props.type === 'go') && !this.props.manualEntryAdd.isAddMode) {
      
    console.log('🚀 ~ ManualEntryModalContainer ~ this.state.forwarderValue:', this.state.forwarderValue)
    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
      driverInfo.forwarderLocation = this.state.forwarderLocationValue || 0;

      let finalForwarderValue = this.state.forwarderValue;
      if (!finalForwarderValue && this.props.type === 'go') {
         if (this.state.forwarders && this.state.forwarders.length > 0) {
           finalForwarderValue = this.state.forwarders[0].id;
         } else {
           const fallbackResp = await forwarderRemote.getStationForwarders({ code: this.props.gha.info.location, type: 'go', gha: this.props.gha.id });
           if (fallbackResp && fallbackResp.result && fallbackResp.result.length > 0) {
             finalForwarderValue = fallbackResp.result[0].id;
             this.setState({ forwarders: fallbackResp.result as any, forwarderValue: finalForwarderValue });
           }
         }
      }

      if (!finalForwarderValue) {
        this.props.receiveError({ errorCode: "Missing Forwarder", longDescription: "Forwarder has not been successfully loaded or selected." });
        return;
      }

      forwarderRemote.forwarderImpersonate(finalForwarderValue, driverInfo, this.state.selectedDock, null, this.props.manualEntryEdit.orderId).then((resp: ApiResponse<boolean>) => {

        const success: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;
  
        if (success) {
          this.props.handleCloseModal(false, true);         
          this.props.history.push(this.props.type === 'po' ? '/manual-entry-import' : (this.props.type === 'go' ? '/create-go-order' : '/manual-entry-export'));
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      }); 
    } else if (!isValid && this.props.manualEntryAdd.isAddMode) {
      let finalForwarderValue = this.state.forwarderValue;

      if (!finalForwarderValue && this.props.type === 'go') {
         // Fallback explicitly if forwarderValue is missing for GO
         if (this.state.forwarders && this.state.forwarders.length > 0) {
           finalForwarderValue = this.state.forwarders[0].id;
         } else {
           const fallbackResp = await forwarderRemote.getStationForwarders({ code: this.props.gha.info.location, type: 'go', gha: this.props.gha.id });
           if (fallbackResp && fallbackResp.result && fallbackResp.result.length > 0) {
             finalForwarderValue = fallbackResp.result[0].id;
             this.setState({ forwarders: fallbackResp.result as any, forwarderValue: finalForwarderValue });
           }
         }
      }

      if (!finalForwarderValue) {
        this.props.receiveError({ errorCode: "Missing Forwarder", longDescription: "Forwarder has not been successfully loaded or selected." });
        return;
      }

      const orderId = this.props.manualEntryAdd.orderId;

      forwarderRemote.forwarderImpersonate(finalForwarderValue, driverInfo, this.state.selectedDock, orderId).then((resp: ApiResponse<boolean>) => {

        const success: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;
  
        if (success) {
          this.props.handleCloseModal(false, false);         
          this.props.history.push(this.props.type === 'po' ? '/manual-entry-import' : (this.props.type === 'go' ? '/create-go-order' : '/manual-entry-export'));
        }
  
        if (error) {
          this.props.receiveError(error);
        }
      }); 
    } else {
      // TODO: error
    }
  }

  changeArrivalTime = (value: string): void => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    const valueInPureFormat: string = value.replace(':', '');

    if (!Number.isInteger(Number(valueInPureFormat)) && valueInPureFormat) {
      return;
    }

    driverInfo.arrivalTime = value.length > 5 ? value.substring(0, 5) : value;
    this.setState({ driverInfo }, () => {});
  }

  isValid = (): boolean => {

    const errors: any = { ...this.state.errors };
    const driverInfo: DriverInfoModel = { ... this.state.driverInfo };
    let hasError: boolean = false
    let forwarderError = '';
    const rfsDisabled: boolean = this.state.delivererType === DelivererType.RFS ? false : true;

    if (!this.state.forwarderValue && this.props.type !== 'go') {
      forwarderError = 'Add forwarder';
      hasError = true;
    }

    Object.entries(driverInfo).forEach(([key, value]) => {

      if (value === '' && key !== 'driverIdType' && key !== 'truckPlateNumber' && key !== 'forwarderStation' && key !== 'rfsNumber' && key !== 'interlineTransfer') {
       errors[key] = 'Add';
        hasError = true;
      }

      if (!rfsDisabled && value === '' && key === 'rfsNumber') {
        errors[key] = 'Add';
        hasError = true;
      } 

      if (key === 'arrivalTime') {
      
        var timeSplit: Array<string> = value.split(':');

        const valid: boolean = /^\d\d:\d\d$/.test(value) && Number(timeSplit[0]) >= 0 && Number(timeSplit[0]) <= 23 && Number(timeSplit[1]) >= 0 && Number(timeSplit[1]) < 60;

        if (valid) {
          return;
        }

        errors[key] = 'Invalid';
        hasError = true;
      }
    });

    this.setState({ errors, forwarderError, forwarderNameError: '', forwarderName: '', isCreateFwd: false });
    return hasError;
  }

  handleClick = (event: any) => {

    const errors: any = { ...this.state.errors }
    const key: string = event.target.id;
    if (key === 'company') {
      this.setState({ forwarderError: '', forwarderNameError: '', forwarderName: '', isCreateFwd: false });
    } else if( key === 'forwarderName') {
      this.setState({ forwarderNameError: '' })
    } else if(key === 'driverId') {
      const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
      driverInfo.maskedDriverId = driverInfo.driverId;
      this.setState({ driverInfo });
    } else {
      errors[key] = '';
      this.setState({ errors });
    }
  }

  maskon = () => {

    const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    driverInfo.maskedDriverId =  driverInfo.driverId.replace(/.(?=.{4,}$)/g, '#');
    this.setState ({ driverInfo });
  }

  handleChangeDelivererType = (event: React.ChangeEvent<HTMLInputElement>): void => {

    const delivererType: string = event.target.value;
    this.setState({ delivererType, forwarderName: '', isCreateFwd: false, stationValue: this.props.gha.info.location, cityCodeValue: '', forwarderValue: undefined, forwarderLocationValue: undefined});
    this.loadForwarders(this.props.gha.info.location,delivererType);
  }

  handleUpdateDriverInfo = (event: React.MouseEvent<HTMLButtonElement>): void => {

    const updatedDrvTrkData: DriverTruckEdit = {
      orderNumber: this.props.manualEntryEdit.orderNumber,
      delivery_company_name: this.props.manualEntryEdit.driverData.company,
      delivery_company_name_new: this.state.driverInfo.truckingCompany,
      driver_id: this.state.driverInfo.driverId,
      driver_id_type: this.state.driverInfo.driverIdType,
      driver_name: this.state.driverInfo.driverName,
      driver_vehichle_registration: this.state.driverInfo.truckPlateNumber,
      rfs_number: this.state.driverInfo.rfsNumber,
      id_dock: this.state.selectedDock || null,
      driver_checkin_time: this.state.driverInfo.arrivalTime ? this.state.driverInfo.arrivalTime.replace(':', '') : null
    };

    if (!updatedDrvTrkData.orderNumber || this.isValid()) {
      return;
    }

    pickupOrderRemote.saveGhaExportDriverInfo(updatedDrvTrkData.orderNumber, updatedDrvTrkData).then((resp: ApiResponse<PickupOrderGha>) => {
      const po: PickupOrderGha | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (po) {
        this.props.handleCloseModal(true);
      }
      
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  loadStations = () => {

    forwarderRemote.getStations({ all: false }).then((resp: ApiResponse<Array<StationsModel>>) => {
      let tempStations: any = [];
      tempStations.push({
        "id": -1,
        "iata_code": "Show All"
      });
      let stations: Array<StationsModel> | undefined = tempStations.concat(resp.result);
      const error: ResponseError | undefined = resp.error;
      if (stations) {
        this.setState({ stations });
      }
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  loadCityCodes = () => {

    forwarderRemote.getStations({ all: true }).then((resp: ApiResponse<Array<StationsModel>>) => {
      const cityCodes: Array<StationsModel> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      if (cityCodes) {
        this.setState({ cityCodes });
      }
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleCancelCreateFwd = (): void => {
   
    this.setState({ isCreateFwd: false, forwarderName: '', forwarderNameError: '', stationValue: this.props.gha.info.location, cityCodeValue: '', cityCodeError: '', forwarderValue: undefined, forwarderLocationValue: undefined});
    this.loadForwarders(this.props.gha.info.location,this.state.delivererType);
  }
  
  handleCloseFwdModal = (): void => {

    this.setState({ openModalRecheckFwd: false });
    this.setState({ selectedForwarder: '', selectedForwarderLocationValue: '' });
  }

  handleSelectForwarder = (event: React.ChangeEvent<HTMLInputElement>): void => {

    let selVal: string = event.target.value;
    let selFwdValue = this.state.relevantForwarders.filter(fwd => fwd.forwarder_location_id == Number(selVal));

    this.setState({ selectedForwarder: selFwdValue[0].id });
    this.setState({ selectedForwarderLocationValue: selVal });
  }

  handleAddSelForwarder = (): void => {

    this.setState({ openModalRecheckFwd: false });
    this.loadStations();
    this.setState({ stationValue: this.state.cityCodeValue });
    this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
    this.setState({ cityCodeValue: '', forwarderLocationValue: Number(this.state.selectedForwarderLocationValue), forwarderValue: Number(this.state.selectedForwarder), isCreateFwd: false, selectedForwarder: '', selectedForwarderLocationValue: ''});
  }

  handleAddNewFwd = (): void => {
    //check if fwd name exists & it is inactive
    forwarderRemote.getForwarderByName({forwarder_name: this.state.forwarderName}).then((resp: ApiResponse<Array<ForwarderNewModel>>) => {
      const fwdWName: Array<ForwarderNewModel> | undefined = resp.result;
      const fwdWNameerror: ResponseError | undefined = resp.error;
      if (fwdWNameerror) {
        this.props.receiveError(fwdWNameerror);
      }     
      if (fwdWName) {
        if (fwdWName.length !== 0) {
          // check if fwd has location(s)
          forwarderRemote.getForwarderLocation({fwdId: fwdWName[0].id}).then((resp: ApiResponse<Array<ForwarderLocationModel>>) => {
            const fwdLocations: Array<ForwarderLocationModel> | undefined = resp.result;
            const fwdLocationserror: ResponseError | undefined = resp.error;
            if (fwdLocationserror) {
              this.props.receiveError(fwdLocationserror);
            }
            if (fwdLocations) {
              if (fwdLocations.length === 0) { 
                // check if fwd is active
                if (fwdWName[0].is_active === true) {
                  // add the new location with all active n gha_id
                  forwarderRemote.addForwarderLocation(fwdWName[0].id,this.state.cityCodeValue,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                    const fwdLocation: ForwarderLocationModel | undefined = resp.result;
                    const fwdLocationerror: ResponseError | undefined = resp.error;

                    if (fwdLocation) {
                      this.loadStations();
                      this.setState({ stationValue: this.state.cityCodeValue });

                      this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                      this.setState({ openModalRecheckFwd: false });
                      this.setState({ cityCodeValue: '', forwarderValue: fwdLocation.id_forwarder, forwarderLocationValue: fwdLocation.id, isCreateFwd: false, selectedForwarder: '', selectedForwarderLocationValue: ''});
                    }
                    if (fwdLocationerror) {
                      this.props.receiveError(fwdLocationerror);
                    }
                  }); 
                }
                else { // fwd inactive
                  // update the is_active for fwd to true, added as local & add the new location with all active & gha_id
                  forwarderRemote.updateForwarderStatus(fwdWName[0].id,this.state.cityCodeValue,true,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
                    const activeFwdLocation: ForwarderLocationModel | undefined = resp.result;
                    const activeFwdLocationerror: ResponseError | undefined = resp.error;

                    if (activeFwdLocation) {
                      this.loadStations();
                      this.setState({ stationValue: this.state.cityCodeValue });

                      this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
                      this.setState({ openModalRecheckFwd: false });
                      this.setState({ cityCodeValue: '', forwarderValue: activeFwdLocation.id_forwarder, forwarderLocationValue: activeFwdLocation.id, isCreateFwd: false, selectedForwarder: '', selectedForwarderLocationValue: ''});
                    }
                    if (activeFwdLocationerror) {
                      this.props.receiveError(activeFwdLocationerror);
                    }
                  });
                }                             
              }
            }
          });
        }
        else {        
          // save the location & forwarder name
          forwarderRemote.createForwarder(this.state.forwarderName, 'forwarder', this.state.cityCodeValue, 'local', true,this.props.gha.id).then((resp: ApiResponse<ForwarderLocationModel>) => {
            const forwarder: ForwarderLocationModel | undefined = resp.result;
            const error: ResponseError | undefined = resp.error;

            if (forwarder) {
              this.loadStations();
              this.setState({ stationValue: this.state.cityCodeValue });

              this.loadForwarders(this.state.cityCodeValue,this.state.delivererType);
              this.setState({ openModalRecheckFwd: false });
              this.setState({ cityCodeValue: '', forwarderValue: forwarder.id_forwarder, forwarderLocationValue: forwarder.id, isCreateFwd: false, selectedForwarder: '', selectedForwarderLocationValue: ''});
            }

            if (error) {
              this.props.receiveError(error);
            }
          });          
        }
      }
    });
  }
   
  render () {
    return (
      <ManualEntryModal 
        modalOpen={ this.props.modalOpen }
        forwarderName={ this.state.forwarderName }
        handleCloseModal={ this.props.handleCloseModal }
        forwarders={ this.state.forwarders }
        forwarderValue={ this.state.forwarderValue }
        forwarderLocationValue={ this.state.forwarderLocationValue }
        isCreateFwd={ this.state.isCreateFwd }
        handleOpenCreateFwd={ this.handleOpenCreateFwd }
        handleCreateForwarder={ this.handleCreateForwarder }
        driverInfo={ this.state.driverInfo }
        selectedDock={ this.state.selectedDock }
        docks={ this.state.ghaDocks }
        handleChange={ this.handleChange }
        handleSubmit={ this.handleSubmit }
        errors={ this.state.errors }
        forwarderError={ this.state.forwarderError }
        onClick={ this.handleClick }
        forwarderNameError={ this.state.forwarderNameError }
        delivererType={ this.state.delivererType }
        handleChangeDelivererType={ this.handleChangeDelivererType }
        handleUpdateDriverInfo={ this.handleUpdateDriverInfo }
        type={ this.props.type }
        maskon={ this.maskon }
        stations={ this.state.stations }
        stationValue= { this.state.stationValue }
        cityCodes= { this.state.cityCodes }
        handleCancelCreateFwd= { this.handleCancelCreateFwd }
        cityCodeValue={ this.state.cityCodeValue }
        cityCodeError={ this.state.cityCodeError }
        openModalRecheckFwd={ this.state.openModalRecheckFwd }
        handleCloseFwdModal={ this.handleCloseFwdModal }
        relevantForwarders={ this.state.relevantForwarders }
        selectedForwarder={ this.state.selectedForwarder }
        selectedForwarderLocationValue={ this.state.selectedForwarderLocationValue }
        handleSelectForwarder={ this.handleSelectForwarder }
        handleAddSelForwarder={ this.handleAddSelForwarder }
        handleAddNewFwd= { this.handleAddNewFwd }
        airlines={ this.state.airlines }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    manualEntryEdit: state.manualEntryEdit,
    manualEntryAdd: state.manualEntryAdd,
    gha: state.ghaInfo
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId)),
    getGhaOrderAwbs: (orderNumber: string) => dispatch(receiveGhaOrderAwbs(orderNumber))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManualEntryModalContainer);
